export default __webpack_public_path__ + "static/media/fw-abigail-er-Rose Gold.36a96f06.mp4";